export const infoWidth = 160;
export const boxWidth = 195;